import * as btoa from "btoa";

const config = {
  ws: {
    url: process.env.VUE_APP_WS_URL,
    user: process.env.VUE_APP_WS_AUTH || "QfTjWmZq4t7w!z%C*F-JaNdRgUkXp2r5",
    pass: process.env.VUE_APP_WS_PASS || "z%C*F-JaNdRgUkXp2s5v8y/B?D(G+KbP",
    timeout: 20 * 60 * 1000,
  },
  intervalForExternalPurchase: 30000,
  getWSAuth: () =>
    `Basic ${btoa(
      `${process.env.VUE_APP_WS_AUTH}:${process.env.VUE_APP_WS_PASS}`
    )}`,
  countdownMilliseconds: 900000,
  magic: {
    publishableKey: process.env.VUE_APP_MAGIC_PUBLISHABLE_KEY,
  },
  sentry: {
    dns: process.env.VUE_APP_SENTRY_DNS,
    tracePropagationTargets: JSON.parse(process.env.VUE_APP_TRACE_PROPAGATION_TARGETS || '[]'),
  },
};
export default config;

export const paymentSteps = [
  {
    label: "Payment initiated",
    subLabel: "Your Payment was inititiated...",
  },
  {
    label: "Confirming payment",
    subLabel: "Confirming your payment...",
  },
  {
    label: "Redirecting...",
    subLabel: "Please wait while we redirect you...",
  },
];

export const walletIds = {
  coinbaseWallet: "coinbaseWallet",
  metamaskWallet: "metaMask",
};
export const iframeClient = {
  mobile: "mobile",
  desktop: "desktop",
};

export const recommendedWallet = [
  "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
  "f04122d52804a58d84cf7f89995f67889879b87497f3366fdbfafd9959c90c93",
  "394631c96f2c3201ffd5b3f3f249028163a893ae2ff9076882350e70f3450cb0",
  "4c70c9bd85cc4707811ec0912d692855370d465d46188be42530eaeb4a4f3cae",
  "6e5c50b9bbef9003af00f0c7eea0e519c28356d5c035d7e58678429181c4a668",
  "8f713ff1e4f0b6b94fd0f87a58089642437890a0e10d6d9e5dc3242ab587d8dc",
  "4af6d64924d3e1b2b730d15b360de17e705fd3860da6551008efd7f7a9d1ad6f",
  "ccc6042e12fbbcc1ba48e22d8987b73d32a6c78adf760bd2695ca4147df96833",
  "604a3057f03cc5fe1cc937022ac32a06b7c2069bccb6f4a684cdcd93d2b0f1ce",
  "367bf352c4f0d726ac580321c2d00c9525f5b59045ed38a5b75c331d410f5186",
  "76440f460ab616d254155534cb775942142e54b866ac1cb78a93d92f7c693da8",
];
export const coinbaseWallet =
  "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa";
export const enableWalletConnect = JSON.parse(
  process.env.VUE_APP_WALLET_CONNECT_ENABLED || "false"
);
